import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    FormControl: {
        width: 550
    }
});

export const MSESelectStatus = (props) => {
    const classes = useStyles();
    const {
        inputLabel,
        label,
        value,
        handleChange,
        disabled,
        nameValue,
        ...others
    } = props;
    const statuses = [
        {value: 'ACTIVO', display: 'Activo'},
        {value: 'INACTIVO', display: 'Inactivo'},
        {value: 'EGRESO', display: 'Egreso'},
    ];

    return (
        <FormControl className={classes.formControl}>
            <InputLabel>
                {inputLabel}
            </InputLabel>
            <Select
                labelId={`formcontrol-select-status-${nameValue}`}
                id={`formcontrol-select-status-${nameValue}`}
                value={value || ''}
                onChange={e => handleChange(nameValue,e)}
                required
                className={classes.FormControl}
            >
                {statuses.map((status, i) => <MenuItem value={status.value} key={`f-s-mi-${nameValue}-${i}`}>{status.display}</MenuItem>)}
            </Select>
        </FormControl>
    );
};